// @ts-nocheck
import * as React from 'react';

import { Product as ProductType } from '../types';
import Product from '../components/Product';

interface ProductSectionProps {
  products: ProductType[];
}

const ProductSection: React.FC<ProductSectionProps> = ({ products }) => {
  return (
    <div>
      {products.map((product, index, arr) => (
        <Product
          key={product.id}
          isLast={index === arr.length - 1}
          product={product}
        />
      ))}
    </div>
  );
};

export default ProductSection;
